import { Stack, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import {
  MEMBER_TELEMED_VISIT_COST_CENTS,
  NON_MEMBER_TELEMED_VISIT_COST_CENTS,
} from '~/components/Membership/constants';
import { centsToCurrencyStr } from '~/core/util/currency';

export const VideoVisitMemberPrice = () => (
  <Stack alignItems="center" row space={0.5}>
    <Text muted style={{ textDecoration: 'line-through' }}>
      {centsToCurrencyStr(NON_MEMBER_TELEMED_VISIT_COST_CENTS)}
    </Text>
    <Text as="span" fontWeight="bold" textColor="teal-medium">
      {centsToCurrencyStr(MEMBER_TELEMED_VISIT_COST_CENTS)}
    </Text>
    <img alt="Solv Plus" height={20} src="/images/membership/logo_flat.svg" />
  </Stack>
);
